module.exports = __webpack_public_path__ + "f461b0cc3c2692b7b8475389b6a051ec.png";